import axios from 'axios';
import { useEffect, useState } from 'react';
import apiConfig from 'src/api/APIConfig';
import { REACT_APP_API_ISF, archLevel } from 'src/data/config';
import { store } from 'src/store';
import * as endPointData from '../resources/endpoint.json';
import moment from 'moment';

const constructRequestDetails = (endpoint: any, options: any = {}) => {
  const token =
    options.endPointEnv === 'isf'
      ? (store.getState()?.user?.user as any)?.siteToken
      : (store.getState()?.user?.user as any)?.sponsorToken;
  const sponsor = (store.getState()?.user?.user as any)?.sponsor_sponsor_name;
  const siteUrl = store.getState()?.site?.siteInfo?.site?.hospital_slug_url;
  const input: any = { ...endPointData[endpoint as keyof typeof endPointData] };
  let url = `${apiConfig.appConfig.apictms}/${input.url}`;
  if (options.endPointEnv === 'etmf') {
    url = `${apiConfig.appConfig.apietmf}/${input.url}`;
  } else if (options.endPointEnv === 'isf') {
    if (archLevel == 'site') {
      url = `${REACT_APP_API_ISF}/${input.url}`;
    } else if (archLevel == 'sponsor') {
      url = `https://isf-api-${siteUrl}/isf/${input.url}`;
    }
  } else if (options.endPointEnv === 'sysadmin') {
    url = `${apiConfig.appConfig.apisysadmin}/${input.url}`;
  }
  if (options.pathVariables) {
    url = `${url}?${input.path_variables}`;
    for (const [key, value] of Object.entries(options.pathVariables)) {
      const encodeVal = value ? encodeURIComponent(value as any) : value;
      url = url.replace(`#${key}`, encodeVal as any);
    }
  }
  if (input.config_value) {
    for (const key of input.config_value) {
      const encodeVal = options[key] ? encodeURIComponent(options[key]) : options[key];
      url = url.replace(key, encodeVal);
    }
  }
  if (input.headers && input.headers.length) {
    for (const header of input.headers) {
      if (options.body && (options.body[header.key] || options.body[header.key] === 0)) {
        header.value = options.body[header.key];
      }
    }
    if (input.method === 'get') {
      delete options.body;
    }
  }
  options.url = url;
  options.headers = {
    authorization: `Bearer ${token}`,
    sponsor,
    ...(options.endPointEnv === 'isf'
      ? {
          sponsor_token: (store.getState()?.user?.user as any)?.sponsorToken
        }
      : { site_token: (store.getState()?.user?.user as any)?.siteToken }),
    user_date_time: moment().format()
  };
  options.method = input.method;
  return options;
};

const sendRequest = (endpoint: any, options: any = {}) => {
  const requestDetails = constructRequestDetails(endpoint, options);
  const promise = new Promise((resolve, reject) => {
    axios(requestDetails)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
 
  return promise;
};

const useFetch = (endpoint: any, options: any = {}) => {
  const [data, setData] = useState<any>(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsCompleted(false);
    setData(null);
    setError(null);
    const source = axios.CancelToken.source();
    const requestDetails = constructRequestDetails(endpoint, options);
    axios(requestDetails, { cancelToken: source.token })
      .then(res => {
        setIsCompleted(true);
        //checking for multiple responses for more flexibility
        //with the url we send in.
        res.data && setData(res.data);
      })
      .catch(err => {
        setIsCompleted(true);
        setError(err);
      });
    return () => {
      source.cancel();
    };
  }, [endpoint]);

  return { data, isCompleted, error };
};

export { constructRequestDetails, sendRequest, useFetch };
